import { BlockDefinition } from '../../../types/pageBuilder';

const icons = {
  features: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="7" height="7" rx="1.5"/>
    <rect x="14" y="3" width="7" height="7" rx="1.5"/>
    <rect x="3" y="14" width="7" height="7" rx="1.5"/>
    <rect x="14" y="14" width="7" height="7" rx="1.5"/>
  </svg>`,
  featuresCards: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="8" height="8" rx="2"/>
    <rect x="13" y="3" width="8" height="8" rx="2"/>
    <rect x="3" y="13" width="8" height="8" rx="2"/>
    <rect x="13" y="13" width="8" height="8" rx="2"/>
    <circle cx="7" cy="7" r="1" fill="currentColor"/>
    <circle cx="17" cy="7" r="1" fill="currentColor"/>
  </svg>`,
  testimonials: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <path d="M8 12h.01M12 12h.01M16 12h.01"/>
    <path d="M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
  </svg>`,
  faq: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <circle cx="12" cy="12" r="9"/>
    <path d="M9 9a3 3 0 115 2.83c0 1.17-2 1.17-2 2.17"/>
    <circle cx="12" cy="17" r="0.5" fill="currentColor"/>
  </svg>`,
  stats: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="4" y="13" width="4" height="8" rx="1"/>
    <rect x="10" y="9" width="4" height="12" rx="1"/>
    <rect x="16" y="4" width="4" height="17" rx="1"/>
  </svg>`
};

const imageIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
    <path d="M21 15l-5-5L5 21"/>
  </svg>`;

const imageGalleryIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="2" y="2" width="9" height="9" rx="1"/>
    <rect x="13" y="2" width="9" height="9" rx="1"/>
    <rect x="2" y="13" width="9" height="9" rx="1"/>
    <rect x="13" y="13" width="9" height="9" rx="1"/>
  </svg>`;

const imageBannerIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="2" y="6" width="20" height="12" rx="2"/>
    <circle cx="7" cy="10" r="1.5" fill="currentColor"/>
    <path d="M22 14l-4-4-6 6"/>
  </svg>`;

export const contentBlocks: BlockDefinition[] = [
  // ===== IMAGE BLOCKS =====
  {
    id: 'image-simple',
    label: 'Imagem',
    category: 'Imagens',
    media: imageIcon,
    content: `
      <div style="padding: 20px; text-align: center;">
        <img src="https://placehold.co/800x500/e2e8f0/64748b?text=Clique+duas+vezes+para+trocar" alt="Imagem" style="max-width: 100%; height: auto; border-radius: 12px;" />
      </div>
    `,
    attributes: { class: 'gjs-block-image' }
  },
  {
    id: 'image-rounded',
    label: 'Imagem Arredondada',
    category: 'Imagens',
    media: imageIcon,
    content: `
      <div style="padding: 20px; text-align: center;">
        <img src="https://placehold.co/400x400/e2e8f0/64748b?text=Sua+Foto" alt="Imagem" style="width: 250px; height: 250px; object-fit: cover; border-radius: 50%; box-shadow: 0 10px 30px rgba(0,0,0,0.15);" />
      </div>
    `,
    attributes: { class: 'gjs-block-image' }
  },
  {
    id: 'image-card',
    label: 'Imagem com Legenda',
    category: 'Imagens',
    media: imageIcon,
    content: `
      <div style="max-width: 500px; margin: 20px auto; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.1); background: white;">
        <img src="https://placehold.co/500x300/e2e8f0/64748b?text=Sua+Imagem" alt="Imagem" style="width: 100%; height: 300px; object-fit: cover;" />
        <div style="padding: 20px;">
          <h3 style="font-size: 1.25rem; font-weight: 700; color: #111827; margin-bottom: 8px;">Titulo da Imagem</h3>
          <p style="color: #6b7280; font-size: 0.95rem; line-height: 1.6;">Descricao breve sobre esta imagem ou conteudo visual.</p>
        </div>
      </div>
    `,
    attributes: { class: 'gjs-block-image' }
  },
  {
    id: 'image-banner-full',
    label: 'Banner Full Width',
    category: 'Imagens',
    media: imageBannerIcon,
    content: `
      <section style="position: relative; width: 100%; height: 400px; overflow: hidden;">
        <img src="https://placehold.co/1400x400/1e293b/94a3b8?text=Banner+Full+Width" alt="Banner" style="width: 100%; height: 100%; object-fit: cover;" />
        <div style="position: absolute; inset: 0; background: linear-gradient(to right, rgba(0,0,0,0.6), transparent); display: flex; align-items: center; padding: 0 60px;">
          <div>
            <h2 style="font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 12px;">Titulo do Banner</h2>
            <p style="font-size: 1.125rem; color: rgba(255,255,255,0.85);">Subtitulo ou descricao do banner aqui.</p>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-image' }
  },
  {
    id: 'image-gallery-grid',
    label: 'Galeria de Imagens',
    category: 'Imagens',
    media: imageGalleryIcon,
    content: `
      <section style="padding: 60px 20px;">
        <div style="max-width: 1200px; margin: 0 auto;">
          <h2 style="text-align: center; font-size: 2rem; font-weight: 700; color: #111827; margin-bottom: 40px;">Galeria</h2>
          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;">
            <img src="https://placehold.co/400x300/e2e8f0/64748b?text=Foto+1" alt="Foto 1" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;" />
            <img src="https://placehold.co/400x300/dbeafe/3b82f6?text=Foto+2" alt="Foto 2" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;" />
            <img src="https://placehold.co/400x300/fef3c7/f59e0b?text=Foto+3" alt="Foto 3" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;" />
            <img src="https://placehold.co/400x300/dcfce7/22c55e?text=Foto+4" alt="Foto 4" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;" />
            <img src="https://placehold.co/400x300/fce7f3/ec4899?text=Foto+5" alt="Foto 5" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;" />
            <img src="https://placehold.co/400x300/f3e8ff/a855f7?text=Foto+6" alt="Foto 6" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;" />
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-image' }
  },
  {
    id: 'features-grid-3',
    label: 'Grade de Recursos',
    category: 'Conteúdo',
    media: icons.features,
    content: `
      <section class="features-section" style="padding: 100px 20px; background-color: #ffffff;">
        <div style="max-width: 1200px; margin: 0 auto;">
          <div style="text-align: center; margin-bottom: 60px;">
            <h2 style="font-size: 2.5rem; font-weight: 700; color: #111827; margin-bottom: 16px;">
              Por que nos escolher?
            </h2>
            <p style="font-size: 1.125rem; color: #6b7280; max-width: 600px; margin: 0 auto;">
              Recursos que fazem a diferenca no seu dia a dia
            </p>
          </div>
          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px;">
            <div style="text-align: center; padding: 32px;">
              <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px;">
                <svg width="32" height="32" fill="none" stroke="#4f46e5" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
                </svg>
              </div>
              <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 12px;">
                Super Rapido
              </h3>
              <p style="color: #6b7280; line-height: 1.6;">
                Performance otimizada para entregar resultados em tempo recorde.
              </p>
            </div>
            <div style="text-align: center; padding: 32px;">
              <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #dcfce7 0%, #d1fae5 100%); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px;">
                <svg width="32" height="32" fill="none" stroke="#059669" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                </svg>
              </div>
              <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 12px;">
                100% Seguro
              </h3>
              <p style="color: #6b7280; line-height: 1.6;">
                Seus dados protegidos com criptografia de ponta a ponta.
              </p>
            </div>
            <div style="text-align: center; padding: 32px;">
              <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px;">
                <svg width="32" height="32" fill="none" stroke="#d97706" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 12px;">
                Custo-Beneficio
              </h3>
              <p style="color: #6b7280; line-height: 1.6;">
                Planos acessiveis com o melhor retorno sobre investimento.
              </p>
            </div>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'features-cards',
    label: 'Cards de Recursos',
    category: 'Conteúdo',
    media: icons.featuresCards,
    content: `
      <section class="features-cards" style="padding: 100px 20px; background-color: #f9fafb;">
        <div style="max-width: 1200px; margin: 0 auto;">
          <div style="text-align: center; margin-bottom: 60px;">
            <h2 style="font-size: 2.5rem; font-weight: 700; color: #111827; margin-bottom: 16px;">
              Tudo que voce precisa
            </h2>
            <p style="font-size: 1.125rem; color: #6b7280;">
              Uma solucao completa para todas as suas necessidades
            </p>
          </div>
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px;">
            <div style="background: white; padding: 32px; border-radius: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="width: 48px; height: 48px; background-color: #eef2ff; border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                <svg width="24" height="24" fill="none" stroke="#4f46e5" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                </svg>
              </div>
              <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 8px;">
                Analytics Avancado
              </h3>
              <p style="color: #6b7280; line-height: 1.6;">
                Dashboards completos com metricas em tempo real para tomar decisoes baseadas em dados.
              </p>
            </div>
            <div style="background: white; padding: 32px; border-radius: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="width: 48px; height: 48px; background-color: #fef3c7; border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                <svg width="24" height="24" fill="none" stroke="#d97706" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 8px;">
                Automatizacao
              </h3>
              <p style="color: #6b7280; line-height: 1.6;">
                Automatize tarefas repetitivas e foque no que realmente importa para seu negocio.
              </p>
            </div>
            <div style="background: white; padding: 32px; border-radius: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="width: 48px; height: 48px; background-color: #dcfce7; border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                <svg width="24" height="24" fill="none" stroke="#059669" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 8px;">
                Colaboracao
              </h3>
              <p style="color: #6b7280; line-height: 1.6;">
                Trabalhe em equipe com ferramentas colaborativas e permissoes personalizadas.
              </p>
            </div>
            <div style="background: white; padding: 32px; border-radius: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="width: 48px; height: 48px; background-color: #fce7f3; border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                <svg width="24" height="24" fill="none" stroke="#db2777" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </div>
              <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 8px;">
                Media Library
              </h3>
              <p style="color: #6b7280; line-height: 1.6;">
                Gerencie todos os seus arquivos de midia em um unico lugar organizado.
              </p>
            </div>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'testimonials-grid',
    label: 'Depoimentos',
    category: 'Conteúdo',
    media: icons.testimonials,
    content: `
      <section class="testimonials" style="padding: 100px 20px; background-color: #ffffff;">
        <div style="max-width: 1200px; margin: 0 auto;">
          <div style="text-align: center; margin-bottom: 60px;">
            <h2 style="font-size: 2.5rem; font-weight: 700; color: #111827; margin-bottom: 16px;">
              O que nossos clientes dizem
            </h2>
            <p style="font-size: 1.125rem; color: #6b7280;">
              Historias de sucesso de quem ja usa nossa plataforma
            </p>
          </div>
          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px;">
            <div style="background: #f9fafb; padding: 32px; border-radius: 16px;">
              <div style="display: flex; gap: 4px; margin-bottom: 16px;">
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
              </div>
              <p style="color: #4b5563; font-style: italic; line-height: 1.7; margin-bottom: 24px;">
                "Incrivel! Aumentamos nossas vendas em 300% nos primeiros 3 meses. A plataforma e intuitiva e o suporte e excepcional."
              </p>
              <div style="display: flex; align-items: center; gap: 12px;">
                <img src="https://placehold.co/48x48/e5e7eb/6b7280?text=MS" alt="Avatar" style="width: 48px; height: 48px; border-radius: 50%;">
                <div>
                  <p style="font-weight: 600; color: #111827;">Maria Silva</p>
                  <p style="font-size: 0.875rem; color: #6b7280;">CEO, TechCorp</p>
                </div>
              </div>
            </div>
            <div style="background: #f9fafb; padding: 32px; border-radius: 16px;">
              <div style="display: flex; gap: 4px; margin-bottom: 16px;">
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
              </div>
              <p style="color: #4b5563; font-style: italic; line-height: 1.7; margin-bottom: 24px;">
                "A melhor decisao que tomamos foi adotar esta plataforma. Economizamos tempo e recursos enquanto crescemos."
              </p>
              <div style="display: flex; align-items: center; gap: 12px;">
                <img src="https://placehold.co/48x48/e5e7eb/6b7280?text=JS" alt="Avatar" style="width: 48px; height: 48px; border-radius: 50%;">
                <div>
                  <p style="font-weight: 600; color: #111827;">Joao Santos</p>
                  <p style="font-size: 0.875rem; color: #6b7280;">Diretor de Marketing, StartupX</p>
                </div>
              </div>
            </div>
            <div style="background: #f9fafb; padding: 32px; border-radius: 16px;">
              <div style="display: flex; gap: 4px; margin-bottom: 16px;">
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <svg width="20" height="20" fill="#fbbf24" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
              </div>
              <p style="color: #4b5563; font-style: italic; line-height: 1.7; margin-bottom: 24px;">
                "Suporte excepcional e resultados impressionantes. Nossa equipe agora trabalha com muito mais eficiencia."
              </p>
              <div style="display: flex; align-items: center; gap: 12px;">
                <img src="https://placehold.co/48x48/e5e7eb/6b7280?text=AC" alt="Avatar" style="width: 48px; height: 48px; border-radius: 50%;">
                <div>
                  <p style="font-weight: 600; color: #111827;">Ana Costa</p>
                  <p style="font-size: 0.875rem; color: #6b7280;">Founder, DigitalCo</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'faq-accordion',
    label: 'Perguntas Frequentes',
    category: 'Conteúdo',
    media: icons.faq,
    content: `
      <section class="faq-section" style="padding: 100px 20px; background-color: #f9fafb;">
        <div style="max-width: 800px; margin: 0 auto;">
          <div style="text-align: center; margin-bottom: 60px;">
            <h2 style="font-size: 2.5rem; font-weight: 700; color: #111827; margin-bottom: 16px;">
              Perguntas Frequentes
            </h2>
            <p style="font-size: 1.125rem; color: #6b7280;">
              Tire suas duvidas sobre nossa plataforma
            </p>
          </div>
          <div style="display: flex; flex-direction: column; gap: 16px;">
            <div style="background: white; border-radius: 12px; padding: 24px; margin-bottom: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; gap: 12px;">
                <h3 style="font-size: 1.125rem; font-weight: 600; color: #111827; margin: 0; flex: 1;">Como funciona o periodo de teste?</h3>
                <svg width="20" height="20" fill="none" stroke="#6b7280" stroke-width="2" viewBox="0 0 24 24" style="flex-shrink: 0;">
                  <path d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
              <p style="color: #6b7280; line-height: 1.6;">
                Voce tem 7 dias gratuitos para testar todas as funcionalidades da plataforma. Nao e necessario cartao de credito para comecar.
              </p>
            </div>
            <div style="background: white; border-radius: 12px; padding: 24px; margin-bottom: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; gap: 12px;">
                <h3 style="font-size: 1.125rem; font-weight: 600; color: #111827; margin: 0; flex: 1;">Posso cancelar a qualquer momento?</h3>
                <svg width="20" height="20" fill="none" stroke="#6b7280" stroke-width="2" viewBox="0 0 24 24" style="flex-shrink: 0;">
                  <path d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
              <p style="color: #6b7280; line-height: 1.6;">
                Sim, voce pode cancelar sua assinatura a qualquer momento, sem multas ou taxas adicionais. O acesso continua ate o fim do periodo pago.
              </p>
            </div>
            <div style="background: white; border-radius: 12px; padding: 24px; margin-bottom: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; gap: 12px;">
                <h3 style="font-size: 1.125rem; font-weight: 600; color: #111827; margin: 0; flex: 1;">Quais formas de pagamento sao aceitas?</h3>
                <svg width="20" height="20" fill="none" stroke="#6b7280" stroke-width="2" viewBox="0 0 24 24" style="flex-shrink: 0;">
                  <path d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
              <p style="color: #6b7280; line-height: 1.6;">
                Aceitamos cartao de credito (Visa, Mastercard, Amex), boleto bancario e PIX. Para planos anuais, oferecemos desconto especial.
              </p>
            </div>
            <div style="background: white; border-radius: 12px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; gap: 12px;">
                <h3 style="font-size: 1.125rem; font-weight: 600; color: #111827; margin: 0; flex: 1;">Oferecem suporte tecnico?</h3>
                <svg width="20" height="20" fill="none" stroke="#6b7280" stroke-width="2" viewBox="0 0 24 24" style="flex-shrink: 0;">
                  <path d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
              <p style="color: #6b7280; line-height: 1.6;">
                Sim! Temos suporte por email, chat e telefone. Planos Pro e Enterprise contam com suporte prioritario 24/7.
              </p>
            </div>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'stats-section',
    label: 'Estatísticas',
    category: 'Conteúdo',
    media: icons.stats,
    content: `
      <section class="stats-section" style="padding: 80px 20px; background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);">
        <div style="max-width: 1200px; margin: 0 auto;">
          <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; text-align: center;">
            <div>
              <p style="font-size: 3.5rem; font-weight: 800; color: white; margin-bottom: 8px;">10k+</p>
              <p style="color: rgba(255,255,255,0.8); font-size: 1rem;">Clientes ativos</p>
            </div>
            <div>
              <p style="font-size: 3.5rem; font-weight: 800; color: white; margin-bottom: 8px;">99.9%</p>
              <p style="color: rgba(255,255,255,0.8); font-size: 1rem;">Uptime garantido</p>
            </div>
            <div>
              <p style="font-size: 3.5rem; font-weight: 800; color: white; margin-bottom: 8px;">50M+</p>
              <p style="color: rgba(255,255,255,0.8); font-size: 1rem;">Mensagens enviadas</p>
            </div>
            <div>
              <p style="font-size: 3.5rem; font-weight: 800; color: white; margin-bottom: 8px;">4.9</p>
              <p style="color: rgba(255,255,255,0.8); font-size: 1rem;">Avaliacao media</p>
            </div>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-content' }
  },

  // ============ IMAGE BLOCKS ============
  {
    id: 'image-full',
    label: 'Imagem Full Width',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="20" height="16" rx="2"/><circle cx="8" cy="10" r="2"/><path d="M2 16l5-5 3 3 4-4 8 8"/></svg>`,
    content: `
      <div style="width: 100%; padding: 0;">
        <img src="https://placehold.co/1200x500/e5e7eb/6b7280?text=Imagem+Full+Width" alt="Imagem" style="width: 100%; height: auto; display: block;">
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'image-rounded',
    label: 'Imagem Arredondada',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="6"/><circle cx="9" cy="9" r="1.5"/><path d="M3 17l5-5 3 3 4-4 6 6"/></svg>`,
    content: `
      <div style="padding: 20px; text-align: center;">
        <img src="https://placehold.co/600x400/e5e7eb/6b7280?text=Arredondada" alt="Imagem" style="width: 100%; max-width: 600px; height: auto; border-radius: 24px; box-shadow: 0 10px 40px rgba(0,0,0,0.1);">
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'image-circle',
    label: 'Imagem Circular',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><circle cx="9" cy="10" r="1.5"/><path d="M5 17l4-4 2 2 3-3 5 5"/></svg>`,
    content: `
      <div style="padding: 20px; text-align: center;">
        <img src="https://placehold.co/400x400/e5e7eb/6b7280?text=Circular" alt="Imagem" style="width: 250px; height: 250px; border-radius: 50%; object-fit: cover; box-shadow: 0 8px 30px rgba(0,0,0,0.12);">
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'image-grid-2',
    label: 'Grid 2 Imagens',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="9" height="18" rx="2"/><rect x="13" y="3" width="9" height="18" rx="2"/></svg>`,
    content: `
      <div style="display: flex; gap: 16px; padding: 20px;">
        <div style="flex: 1;"><img src="https://placehold.co/600x400/dbeafe/3b82f6?text=Imagem+1" alt="Imagem 1" style="width: 100%; height: 300px; object-fit: cover; border-radius: 16px;"></div>
        <div style="flex: 1;"><img src="https://placehold.co/600x400/fce7f3/ec4899?text=Imagem+2" alt="Imagem 2" style="width: 100%; height: 300px; object-fit: cover; border-radius: 16px;"></div>
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'image-grid-3',
    label: 'Grid 3 Imagens',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="6" height="18" rx="1"/><rect x="9" y="3" width="6" height="18" rx="1"/><rect x="16" y="3" width="6" height="18" rx="1"/></svg>`,
    content: `
      <div style="display: flex; gap: 12px; padding: 20px;">
        <div style="flex: 1;"><img src="https://placehold.co/400x400/dbeafe/3b82f6?text=1" alt="Imagem 1" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;"></div>
        <div style="flex: 1;"><img src="https://placehold.co/400x400/dcfce7/22c55e?text=2" alt="Imagem 2" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;"></div>
        <div style="flex: 1;"><img src="https://placehold.co/400x400/fef3c7/f59e0b?text=3" alt="Imagem 3" style="width: 100%; height: 250px; object-fit: cover; border-radius: 12px;"></div>
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'image-text-left',
    label: 'Imagem + Texto (Esquerda)',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="9" height="18" rx="2"/><line x1="14" y1="6" x2="22" y2="6"/><line x1="14" y1="10" x2="22" y2="10"/><line x1="14" y1="14" x2="20" y2="14"/></svg>`,
    content: `
      <section style="padding: 60px 20px;">
        <div style="max-width: 1100px; margin: 0 auto; display: flex; align-items: center; gap: 48px; flex-wrap: wrap;">
          <div style="flex: 1; min-width: 300px;">
            <img src="https://placehold.co/600x500/e0e7ff/4f46e5?text=Sua+Imagem" alt="Imagem" style="width: 100%; height: auto; border-radius: 20px; box-shadow: 0 20px 60px rgba(0,0,0,0.1);">
          </div>
          <div style="flex: 1; min-width: 300px;">
            <h2 style="font-size: 2.25rem; font-weight: 800; color: #1f2937; margin-bottom: 16px; line-height: 1.2;">Titulo do seu conteudo aqui</h2>
            <p style="font-size: 1.125rem; color: #6b7280; line-height: 1.75; margin-bottom: 24px;">Descreva seu produto ou servico com detalhes que engajam o visitante e o convencem a tomar uma acao.</p>
            <a href="#" style="display: inline-block; padding: 14px 32px; background: linear-gradient(135deg, #6366f1, #8b5cf6); color: white; border-radius: 12px; font-weight: 600; text-decoration: none; font-size: 1rem;">Saiba Mais</a>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'gradient-section',
    label: 'Seção com Gradiente',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="18" rx="3"/><path d="M2 8h20M2 13h20M2 18h20" opacity="0.3"/></svg>`,
    content: `
      <section style="padding: 80px 20px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); text-align: center;">
        <div style="max-width: 800px; margin: 0 auto;">
          <h2 style="font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px;">Titulo com Gradiente de Fundo</h2>
          <p style="font-size: 1.25rem; color: rgba(255,255,255,0.9); margin-bottom: 32px;">Uma secao visualmente impactante com fundo gradiente que destaca seu conteudo principal.</p>
          <a href="#" style="display: inline-block; padding: 16px 40px; background: white; color: #6366f1; border-radius: 50px; font-weight: 700; text-decoration: none; font-size: 1.1rem; box-shadow: 0 4px 15px rgba(0,0,0,0.2);">Comece Agora</a>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'gradient-text',
    label: 'Texto com Gradiente',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><text x="3" y="18" font-size="16" font-weight="bold" fill="currentColor">Aa</text></svg>`,
    content: `
      <div style="padding: 40px 20px; text-align: center;">
        <h2 style="font-size: 3rem; font-weight: 900; background: linear-gradient(135deg, #667eea, #764ba2, #f093fb); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; line-height: 1.2; margin-bottom: 16px;">Texto com Gradiente</h2>
        <p style="font-size: 1.125rem; color: #6b7280; max-width: 600px; margin: 0 auto;">Destaque seus titulos com gradientes vibrantes que chamam atencao.</p>
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'gradient-button',
    label: 'Botão Gradiente',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="7" width="18" height="10" rx="5"/><line x1="8" y1="12" x2="16" y2="12"/></svg>`,
    content: `
      <div style="padding: 20px; text-align: center;">
        <a href="#" data-component-type="button" class="gjs-custom-btn"
           data-btn-action="link"
           data-gradient-from="#f093fb" data-gradient-to="#f5576c"
           data-gradient-from-pct="0" data-gradient-to-pct="100"
           data-gradient-angle="135"
           style="display: inline-block; padding: 16px 48px; background: linear-gradient(135deg, #f093fb, #f5576c); color: white; border-radius: 50px; font-weight: 700; text-decoration: none; font-size: 1.1rem; box-shadow: 0 8px 25px rgba(245,87,108,0.35); transition: transform 0.2s, box-shadow 0.2s;">Botao Gradiente</a>
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },

  // ============ IMAGEM COM POSICAO LIVRE ============
  {
    id: 'image-free-position',
    label: 'Imagem Livre (Posicao Absoluta)',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2" stroke-dasharray="4 2"/><rect x="7" y="7" width="10" height="8" rx="1"/><circle cx="10" cy="10" r="1.5"/><path d="M7 13l3-3 2 2 3-3 2 2"/></svg>`,
    content: `
      <div style="position: relative; min-height: 400px; padding: 20px;">
        <img src="https://placehold.co/400x300/e0e7ff/4f46e5?text=Imagem+Livre" alt="Imagem"
             style="position: absolute; top: 50px; left: 50px; width: 300px; height: auto; border-radius: 12px; box-shadow: 0 10px 30px rgba(0,0,0,0.15); cursor: move; z-index: 2;">
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'image-overlay-text',
    label: 'Imagem com Texto Sobreposto',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="20" height="16" rx="2"/><line x1="6" y1="14" x2="18" y2="14"/><line x1="8" y1="18" x2="16" y2="18"/></svg>`,
    content: `
      <div style="position: relative; overflow: hidden; border-radius: 16px;">
        <img src="https://placehold.co/1200x600/1f2937/374151?text=Imagem+de+Fundo" alt="Fundo"
             style="width: 100%; height: 500px; object-fit: cover; display: block;">
        <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.7) 100%); display: flex; flex-direction: column; justify-content: flex-end; padding: 48px;">
          <h2 style="font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 12px;">Seu Titulo Aqui</h2>
          <p style="font-size: 1.125rem; color: rgba(255,255,255,0.85); max-width: 600px; margin-bottom: 24px;">Descricao sobre a imagem com gradiente de sobreposicao para melhor legibilidade do texto.</p>
          <a href="#" style="display: inline-block; padding: 14px 28px; background: white; color: #111827; font-weight: 600; border-radius: 8px; text-decoration: none; width: fit-content;">Saiba Mais</a>
        </div>
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'image-with-border-custom',
    label: 'Imagem com Borda Personalizada',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="4"/><rect x="5" y="5" width="14" height="14" rx="2" stroke-dasharray="3 2"/></svg>`,
    content: `
      <div style="padding: 40px; text-align: center;">
        <img src="https://placehold.co/500x500/dbeafe/3b82f6?text=Sua+Imagem" alt="Imagem"
             data-border-style="rounded-lg"
             data-border-width="4"
             data-border-color="#e5e7eb"
             data-shadow="lg"
             data-opacity="100"
             style="width: 100%; max-width: 500px; height: auto; border-radius: 16px; border: 4px solid #e5e7eb; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);">
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },
  {
    id: 'image-blob-shape',
    label: 'Imagem Blob Organico',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><ellipse cx="12" cy="12" rx="9" ry="8" transform="rotate(15 12 12)"/></svg>`,
    content: `
      <div style="padding: 40px; text-align: center;">
        <img src="https://placehold.co/500x500/fce7f3/ec4899?text=Blob" alt="Imagem"
             data-border-style="blob-1"
             data-shadow="xl"
             style="width: 300px; height: 300px; object-fit: cover; border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25);">
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },

  // ============ SECAO COM GRADIENTE CONFIGURAVEL ============
  {
    id: 'section-gradient-configurable',
    label: 'Secao Gradiente Configuravel',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="18" rx="3"/><path d="M2 8l20-5v18l-20-5z" opacity="0.2" fill="currentColor"/></svg>`,
    content: `
      <section data-component-type="gradient-section"
               data-bg-gradient-from="#667eea"
               data-bg-gradient-to="#764ba2"
               data-bg-gradient-from-pct="0"
               data-bg-gradient-to-pct="100"
               data-bg-gradient-angle="135"
               style="padding: 80px 20px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); text-align: center;">
        <div style="max-width: 800px; margin: 0 auto;">
          <h2 style="font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px;">Secao com Gradiente Configuravel</h2>
          <p style="font-size: 1.25rem; color: rgba(255,255,255,0.9); margin-bottom: 32px;">Use o painel de propriedades para ajustar as cores, angulo e porcentagem do gradiente de fundo.</p>
          <a href="#" style="display: inline-block; padding: 16px 40px; background: white; color: #667eea; border-radius: 8px; font-weight: 700; text-decoration: none;">Saiba Mais</a>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-content' }
  },

  // ============ TEXTO GRADIENTE CONFIGURAVEL ============
  {
    id: 'gradient-text-configurable',
    label: 'Texto Gradiente Configuravel',
    category: 'Imagens',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><text x="3" y="18" font-size="16" font-weight="bold" fill="currentColor">Aa</text></svg>`,
    content: `
      <div style="padding: 40px 20px; text-align: center;">
        <h2 data-component-type="gradient-text"
            data-text-gradient-from="#667eea"
            data-text-gradient-to="#f093fb"
            data-text-gradient-angle="135"
            data-text-gradient-from-pct="0"
            data-text-gradient-to-pct="100"
            style="font-size: 3.5rem; font-weight: 900; background: linear-gradient(135deg, #667eea 0%, #f093fb 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; line-height: 1.2; margin-bottom: 16px;">
          Texto com Gradiente Configuravel
        </h2>
        <p style="font-size: 1.125rem; color: #6b7280; max-width: 600px; margin: 0 auto;">Ajuste as cores do gradiente, angulo e porcentagem pelo painel de propriedades.</p>
      </div>
    `,
    attributes: { class: 'gjs-block-content' }
  },

  // ============ BOTAO COM ACOES ============
  {
    id: 'button-action-link',
    label: 'Botao com Acao (Link)',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="7" width="18" height="10" rx="3"/><path d="M10 12h4m-2-2v4"/></svg>`,
    content: `
      <a href="#" data-component-type="button" class="gjs-custom-btn"
         data-btn-action="link"
         data-btn-text="Clique Aqui"
         target="_blank"
         style="display: inline-block; padding: 14px 28px; background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%); color: white; font-weight: 600; border-radius: 8px; text-decoration: none; text-align: center; cursor: pointer;">
        Clique Aqui
      </a>
    `,
    attributes: { class: 'gjs-block-button' }
  },
  {
    id: 'button-action-section',
    label: 'Botao Ir para Secao',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="7" width="18" height="10" rx="3"/><path d="M12 10v4m-2-2l2 2 2-2"/></svg>`,
    content: `
      <a href="#secao-destino" data-component-type="button" class="gjs-custom-btn"
         data-btn-action="section"
         data-btn-text="Ver Mais"
         style="display: inline-block; padding: 14px 28px; background-color: #111827; color: white; font-weight: 600; border-radius: 8px; text-decoration: none; text-align: center; cursor: pointer;">
        Ver Mais
      </a>
    `,
    attributes: { class: 'gjs-block-button' }
  },
  {
    id: 'button-action-submit',
    label: 'Botao Enviar Formulario',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="7" width="18" height="10" rx="3"/><path d="M9 12l2 2 4-4"/></svg>`,
    content: `
      <button type="submit" data-component-type="button"
              data-btn-action="submit"
              data-btn-text="Enviar"
              style="display: inline-block; padding: 14px 28px; background: linear-gradient(135deg, #059669 0%, #10b981 100%); color: white; font-weight: 600; border-radius: 8px; border: none; text-align: center; cursor: pointer; font-size: 1rem;">
        Enviar
      </button>
    `,
    attributes: { class: 'gjs-block-button' }
  },
  // ===== CUSTOM HTML / EMBED =====
  // Drop-in block for pasting raw HTML / iframe snippets (e.g. CRM scheduler embed).
  // The component type is registered in customComponents.ts and exposes a textarea
  // trait so users can paste their code on the right-side settings panel.
  {
    id: 'custom-embed',
    label: 'Código HTML / Embed',
    category: 'Avançado',
    media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
      <polyline points="16 18 22 12 16 6"/>
      <polyline points="8 6 2 12 8 18"/>
    </svg>`,
    content: {
      type: 'custom-embed',
      attributes: {
        'data-gjs-type': 'custom-embed',
        'data-embed-html': '',
        'data-embed-align': 'center'
      },
      style: { padding: '20px' }
    } as any,
    attributes: { class: 'gjs-block-embed' }
  }
];
